const appConfig = {
  // ************************* APi Base Url & API-ClientID / API-ClientSecret  *************************  
  // Test
  //API_BASE_URL: 'https://imsapi.psgtech.ac.in/LoginAPI_Test/Login',
  //API_BASE_URL: 'http://10.1.113.7:5050/Login'
  //API_BASE_URL: 'https://localhost:7182/Login',
  //API_ClientID : 'PSGLoginTest_L0g!nXr@pH5#vB8nW^qYc1$zT3mU6j%oK9gF2lE7dS*J',
  //API_ClientSecret: 'PSGLoginTest_A8$yQr2@tM1#eZ9vP^nK6xH3gC0jL7w%uF4bS5oD*XpJi',
  

  // Live 
  API_BASE_URL: 'https://imsapi.psgtech.ac.in/LoginAPI/Login',  
  API_ClientID : 'PSGLogin_T3$tpR!mA9x@1z#Vb8F&gQw^sN0hK*eLu4cXj7Yt2DoZ',
  API_ClientSecret: 'PSGLogin_S!5dRf9@qWe1#oL8tY^hPn$zK3xGv6uJ%yC2bA7mM*Xp',

  // *************************  Encryption Key ************************* 
  AES_KEY: '9AB44458A485C1481D209A20774D2D6D',
  AES_IV: '8E12399C07726F5A8E12399C07726F5A',

  // *************************  Otp Verify Tag ************************* 
  //  'N'	No OTP	|| 'E'	OTP to Email || 'M'	OTP to Mobile || 'W'	OTP to Whatsapp
  OtpVerify:'N' ,
  // 'M'	OTP to Mobile || 'W'	OTP to Whatsapp
  OtpLogin:'M' ,

  // *************************  Nativation Module Url ************************* 
  //LoginUI:'https://10.1.113.7:8080/',
  //LoginUI:'http://localhost:5050'
};

export default appConfig;
